// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__HB52K","signatureBlock":"Footer_signatureBlock__NQIcg","signature":"Footer_signature__1WPPZ"};